// extracted by mini-css-extract-plugin
export default {"root":"_113JVByWGF","yacd":"_1m2ZsnzFvt","link":"_3TKFOM4Tgj"};